import React from 'react'

import styles from './styles.module.scss'

interface ITitleInput {
  children: any
  title: string
  className?: string
  required?: boolean
}

const TitleInput: React.FC<ITitleInput> = ({ children, title, className = '', required }) => {
  return (
    <div className={`${styles.container} ${className} ${required ? 'item-required' : null}`}>
      <span className={styles.title}>{title}</span>
      {children}
    </div>
  )
}

export default TitleInput
